/** Shopify CDN: Minification failed

Line 12:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 13:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 26:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 42:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 47:2 Transforming let to the configured target environment ("es5") is not supported yet

**/
// Find all text nodes containing ® symbol
function findTextNodesWithSymbol(rootElem, symbol) {
  let nodesWithSymbol = [];
  let walker = document.createTreeWalker(
    rootElem,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: function (node) {
        if (node.nodeValue.includes(symbol)) {
          return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_SKIP;
      }
    }
  );

  let currentNode;
  while ((currentNode = walker.nextNode())) {
    nodesWithSymbol.push(currentNode);
  }
  return nodesWithSymbol;
}

function wrapSymbolWithSup(nodes, symbol) {
  nodes.forEach(node => {
    // Ensure that the symbol is not already wrapped in <sup>
    if (node.parentElement.nodeName.toLowerCase() !== 'sup') {
      node.nodeValue = node.nodeValue.split(symbol).join('<sup>' + symbol + '</sup>');
    }
  });
}

let nodes = findTextNodesWithSymbol(document.body, '®');
wrapSymbolWithSup(nodes, '®');

// Now, parse the newly introduced HTML elements
nodes.forEach(node => {
  let temp = document.createElement('div');
  temp.innerHTML = node.nodeValue;

  // Replace text node with parsed HTML
  while (temp.firstChild) {
    node.parentNode.insertBefore(temp.firstChild, node);
  }
  node.parentNode.removeChild(node);
});
